import { qs } from '$utils/dom.ts';

/**
 * Постраничный скрипт: подключается только на /routes.
 * Файл найден по имени страницы — правки конфига и шаблона не нужны.
 *
 * Здесь живёт то, что относится к странице, а не к компоненту:
 * синхронизация фильтра с адресной строкой (её знает страница, не список).
 */
const FILTER_KEYS = ['from', 'to', 'sort'];

function restore(form: HTMLFormElement): boolean {
    const params = new URLSearchParams(window.location.search);

    for (const key of FILTER_KEYS) {
        const value = params.get(key);
        const control = form.elements.namedItem(key);
        if (value && control instanceof HTMLInputElement) control.value = value;
    }

    return FILTER_KEYS.some((key) => params.get(key));
}

function sync(form: HTMLFormElement): void {
    const params = new URLSearchParams();

    for (const key of FILTER_KEYS) {
        const control = form.elements.namedItem(key);
        const value = control instanceof HTMLInputElement ? control.value.trim() : '';
        if (value) params.set(key, value);
    }

    const search = params.toString();
    window.history.replaceState(null, '', search ? `?${search}` : window.location.pathname);
}

document.addEventListener('app:ready', () => {
    const form = qs<HTMLFormElement>('[data-route-filter]');
    if (!form) return;

    // Фильтр из адресной строки — чтобы ссылкой можно было поделиться.
    if (restore(form)) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

    form.addEventListener('change', () => sync(form));
    form.addEventListener('submit', () => sync(form));
});
